<template>
    <div>
        <table class="table table-compact table-definition stack-xs">
            <tr>
                <td>Amount</td>
                <td>{{value.amount | monetizeExplicit(value.currency)}}</td>
            </tr>
            <tr>
                <td>Status</td>
                <td><r-badge :type="getBadgeType('invoiceStatus', value.type)">{{value.statusLabel}}</r-badge></td>
            </tr>
            <tr>
                <td>Id</td>
                <td><router-link :to="{name: 'invoice-details', params: {id: value.id}}">{{value.id}}</router-link></td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {getBadgeType} from '@/data/badges-color-map';

    export default {
        name: 'search-result-title-invoices',
        props: {
            value: {
                type: Object,
                required: true,
            },
        },
        methods: {
            getBadgeType,
        },
    };
</script>
